// Slider collection listing

var swiper1 = Swiper;
var init = false;
 
function swiperCollectionListing() {
  if (window.innerWidth <= 768) {
    if (!init) {
      init = true;
      swiper1 = new Swiper(".js-collections-swiper", {
        slidesPerView: 3,
        loop: true,
      });
    }
  } else if (init) {
    swiper1.destroy();
    init = false;
  }
}
swiperCollectionListing();


// Cart Drawer 


// function updateCartItemCounts(count) {
//   document.querySelectorAll('.o-main-header__cart--link-span').forEach(el => {
//     el.textContent = count;
//   })
// }

// async function updateCartDrawer() {
//   const res = await fetch('/?section_id=main-header');
//   const text = await res.text();
//   const html = document.createElement('div');
//   html.innerHTML = text;

//   const newBox = html.querySelector('.c-cart-template__columns').innerHTML;
//   document.querySelector('.c-cart-template__columns').innerHTML = newBox;

//   addCartDrawerListeners();
// }

// function changeItemQuantity(key, quantity) {
//   axios.post('/cart/change.js', {
//     id: key,
//     quantity,
//   }).then(res => {
//     const totalPrice = res.data.total_price;
//     const item = res.data.items.find(item => item.key === key);
//     const itemPrice = item.final_line_price;

//     // document.querySelector('#total-price').textContent = totalPrice;

//     // console.log({totalPrice, item});
//   })
// }

// function addCartDrawerListeners() {
//   document.querySelectorAll('.o-quantity-selector__inner button').forEach((button) => {

//     button.addEventListener('click', async () => {
//       const rootItem = button.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;

//       const key = rootItem.getAttribute('data-line-item-key');
//       const currentQuantity = Number(button.parentElement.querySelector('input').value);
//       const isUp = button.classList.contains('is-plus')
//       const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

//       const res = await fetch('/cart/update.js', {
//         method: "post",
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ updates: { [key]: newQuantity }, })
//       })
//       const cart = await res.json();

//       updateCartItemCounts(cart.item_count)

//       updateCartDrawer();

//     })
//   })
// }
// addCartDrawerListeners()

// document.querySelectorAll('form[action="/cart/add"] button, .c-product-template__add-btn').forEach((form) => {
//   form.addEventListener('click', async (e) => {
//     e.preventDefault();

//     setTimeout(() => {
//       cartDrawer.classList.add('active')
//       overlay.classList.add('active')
//     }, 1000)

//     await fetch("/cart/add", { 
//       method: "post",
//     })
//     await updateCartDrawer()
//   })
// })

// const mediaCart = window.matchMedia("(max-width: 700px)")
//   if (mediaCart.matches){
//     document.querySelectorAll('form[action="/cart/add"] button, .c-product-template__add-btn').forEach((form) => {
//       form.removeEventListener('click', () => {})
//   })   
// }

// document.querySelectorAll('form[action="/cart/add"] button, .c-product-template__add-btn').forEach((form) => {
//   form.removeEventListener('click', () => {})
// })